module.exports = __webpack_public_path__ + "img/bold-icon play.9650f65e.svg";